import React, {useEffect, useState, useMemo} from "react";
import {
    Table,
    TextInput,
    SearchButton,
    LightTextButton,
    Icon,
    FilterDropdown
} from "components";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {internalSearch} from "helper";
import {
    lifestyleRoutingAction,
    categoryAction,
    subCategoriesAction,
    serviceRulesAction
} from "redux/actions";
import RoutingPopup from "../popups/Routing/RoutingPopup";
import {MdEdit} from "react-icons/md";

const initialFilterState = {
    subCategory: ''
};

export default function LifestyleSettingsPanel() {
    const [filterState, setfilterState] = useState(initialFilterState);
    const [tableRows, setTableRows] = useState();
    const [isPopupVisible, setPopupVisible] = useState();
    const [editableDetail, setEditableDetails] = useState();
    const [lifestyle_categories, setLifestyleCategories] = useState();
    const [filterdata, setFilterdata] = useState(false);

    const dispatch = useDispatch();

    const {lifestylerouting, userRole, categories, subCategories, serviceRules} =
        useSelector(state => ({
            serviceRules: state.serviceRules,
            categories: state.categories,
            subCategories: state.subCategories,
            lifestylerouting: state.lifestyleRouting,
            userRole: state.userRole?.filter(role => role.module === "Settings")
        }));

    // Load initially required data
    useEffect(() => {
        dispatch(categoryAction.get());
        dispatch(serviceRulesAction.get());
        dispatch(lifestyleRoutingAction.get());
    }, [dispatch]);

    // Get sub categories based on category selection
    const onCategorySelect = e => {
        const {value} = e.target;

        setfilterState(prev => ({...prev, category: value}));

        if (!value) return;

        dispatch(subCategoriesAction.get(value));
    };


    const onSearch = () => {
        

        var filtered = lifestylerouting.data;
        if (userRole?.find(item => item.privilege === "Read")){
            filtered = (filterState.subCategory != '')?filtered.filter((item) => item.sub_category_id == filterState.subCategory):filtered;
            setFilterdata(filtered);
        }
    };

    useEffect(() => {
        
        var filtered = lifestylerouting ? lifestylerouting.data : null;
        console.log('filtered new  --->'+JSON.stringify(filtered));
        if (Array.isArray(filtered)) {
            let subCategories_ids = subCategories.map((item) => item.id)
            filtered = filtered.filter((item) => subCategories_ids.indexOf(item.subcategory_id) !== -1)
        }
        
        console.log('filtered new  --->'+JSON.stringify(filtered));
        setLifestyleCategories(categories.filter(cat => cat.name == 'Lifestyle+ Activities'));
        if (!filtered?.length) return setTableRows(null);

        if (userRole?.find(item => item.privilege === "Read")){
            filtered = (filterState.subCategory != '')?filtered.filter((item) => item.subcategory_id == filterState.subCategory):filtered;
        }

        // Map table rows
        filtered = filtered?.map(obj => ({
            id: obj?.id,
            sub_category_id: subCategories.find(subCategory => subCategory.id == obj?.subcategory_id)?.name,
            rule_id: obj?.rule_id,
            route_before: obj?.route_before,
            service_duration: obj?.service_duration,
            open_time: obj?.open_time,
            close_time: obj?.close_time,
            min_commission: obj?.min_commission?.toFixed(2),
            max_commission: obj?.max_commission?.toFixed(2),
            amount: obj?.amount?.toFixed(2),
            CreatedAt: `${new Date(obj?.created_at).toLocaleString()}`,
            UpdateAt: `${new Date(obj?.updated_at).toLocaleString()}`,
            edit: (
                <Icon
                    ReactIcon={MdEdit}
                    name="MdEdit"
                    color="primary"
                    onClick={
                        userRole?.find(item => item.privilege === "Read")
                            ? () => {
                                setEditableDetails(obj);
                                setPopupVisible(true);
                            }
                            : null
                    }
                    className="clickable"
                />
            )
        }));
        console.log('filtered new1111111  --->'+JSON.stringify(filtered));
        setTableRows(filtered);
    }, [lifestylerouting, filterState]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "ID",
                sortBy: "id"
            },
            {
                title: "Sub Category",
                sortBy: "sub_category_id"
            },
            {
                title: "Rule",
                sortBy: "rule_id"
            },
            {
                title: "Route Before"
            },
            {
                title: "Service Duration"
            },
            {
                title: "Open"
            },
            {
                title: "Close"
            },
            {
                title: "Min Commission"
            },
            {
                title: "Max Commission"
            },
            {
                title: "Amount"
            },
            {
                title: "Created",
                sortBy: "CreatedAt"
            },
            {
                title: "Updated",
                sortBy: "UpdateAt"
            },
            {
                title: "Edit"
            }
        ],
        [tableRows]
    );

    return (
        <div>
            <div className={styles.filter}>
                <FilterDropdown
                    onChange={onCategorySelect}
                    value={filterState?.category}
                    label="Category"
                    options={[
                        "Pick a category",
                        ...(lifestyle_categories?.map(category => category.name) || [])
                    ]}
                    values={[0, ...(lifestyle_categories?.map(category => category.id) || [])]}
                />
                <FilterDropdown
                    onChange={e =>
                        setfilterState({...filterState, subCategory: e.target.value})
                    }
                    value={filterState?.subCategory}
                    label="Sub Category"
                    options={[
                        "Pick a sub category",
                        ...(subCategories?.map(subCategory => subCategory.name) || [])
                    ]}
                    values={[
                        0,
                        ...(subCategories?.map(subCategory => subCategory.id) || [])
                    ]}
                />
                {/* <FilterDropdown
                    onChange={e =>
                        setfilterState({...filterState, serviceRule: e.target.value})
                    }
                    value={filterState?.serviceRule}
                    label="Service Rule"
                    options={[
                        "Pick a service rule",
                        ...(serviceRules?.map(serviceRule => serviceRule.type) || [])
                    ]}
                    values={[
                        0,
                        ...(serviceRules?.map(serviceRule => serviceRule.id) || [])
                    ]}
                />
                <TextInput
                    search
                    label="City"
                    name="CityID"
                    value={filterState?.CityID}
                    onChange={e =>
                        setfilterState({...filterState, [e.target.name]: e.target.value})
                    }
                /> */}
                {/* <SearchButton onClick={onSearch}/> */}
                {/* <LightTextButton onClick={() => setfilterState(initialFilterState)}/> */}
            </div>
            <Table headers={tableHeaders} data={tableRows}/>
            {isPopupVisible && (
                <RoutingPopup
                    data={editableDetail}
                    closeModal={() => setPopupVisible(false)}
                />
            )}
        </div>
    );
}
